export class MenuModel {
    Id: number;
    Nombre: string;
    Observaciones: string;
    Opciones: MenuOptionsModel[];
    FechaAlta: Date;
    FechaModificacion: Date;
    FechaBaja: Date;
}

export class MenuOptionsModel {
    Id: number;
    MenuId: number;
    PadreId?: number;
    Orden: number;
    TextoId: string;
    AccionId: string;
    SoloMovisat: boolean;
    Observaciones?: string;
    OpcionOriginalId?: number;

    // Agregados
    Level: number;
}

export class MenuAppModel {
    Id: number;
    AplicacionId: number;
    MenuId: number;
}

export class MenuAppEmpModel {
    Id: number;
    AplicacionId: number;
    MenuId: number;
    EmpresaId: number;
}
